import { render } from "./ExplainerScene.vue?vue&type=template&id=4e40c500&scoped=true"
import script from "./ExplainerScene.vue?vue&type=script&lang=js"
export * from "./ExplainerScene.vue?vue&type=script&lang=js"

import "./ExplainerScene.vue?vue&type=style&index=0&id=4e40c500&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e40c500"]])

export default __exports__